import React, { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import SLUGS from 'resources/slugs';
import LoadingComponent from 'components/loading';
//import CreateScratchCard from './createscratchcard';
import ScratchCardProducts from './scratchcards';
import Packages from './packages';
import FarmerPage from './farmer';
import Analytics from './analytics';
import AddPackage from './addpackage';
import PayoutCash from './payoutCash';
import IndividualSavingStatement from './IndividualSavingStatement';
import Credit from './credit';
import Agents from './agents';
// import BulkSms from './bulkSms';
const Transactions = lazy(() => import('../routes/transactions'));
const DashboardComponent = lazy(() => import('./dashboard'));
const Products = lazy(() => import('./products'));
const BulkSms = lazy(() => import('./bulkSms'));

const CreateScratchCard = lazy(() => import('./createscratchcard'));

function PrivateRoutes() {
    return (
        <Suspense fallback={<LoadingComponent loading />}>
            <Routes>
                <Route path={SLUGS.dashboard} element={<DashboardComponent />} />
                <Route path={SLUGS.agents} element={<Agents />} />
                <Route path={SLUGS.credit} element={<Credit />} />
                <Route path={SLUGS.addpackage} element={<AddPackage />} />
                <Route path={SLUGS.analytics} element={<Analytics />} />
                <Route path={SLUGS.farmer} element={<FarmerPage />} />
                <Route path={SLUGS.products} element={<Products />} />
                <Route path={SLUGS.packages} element={<Packages />} />
                <Route path={SLUGS.payoutCash} element={<PayoutCash />} />
                <Route
                    path={SLUGS.individualSavingStatement}
                    element={<IndividualSavingStatement />}
                />
                <Route path={SLUGS.transactions} element={<Transactions />} />
                <Route path={SLUGS.scratchCardsTwo} element={<CreateScratchCard />} />
                <Route path={SLUGS.scratchCards} element={<ScratchCardProducts />} />
                <Route path={SLUGS.bulkSms} element={<BulkSms />} />
                <Route path={SLUGS.contacts} element={<div>contacts</div>} />
                <Route path='*' element={<Navigate to={SLUGS.dashboard} replace />} />
            </Routes>
        </Suspense>
    );
}

export default PrivateRoutes;
